module.exports = __webpack_public_path__ + "img/minigoldenmixseitlich.ed66cba4.jpg";